//Resolves the human readable message to show under a failed upload.
//Returns null when nothing specific should be shown — the widget then
//falls back to its generic "Upload failed" copy — and for axios
//cancellations (the user removed the file mid upload).
export function resolveUploadError(err) {
  if (!err || err.__CANCEL__) {
    return null;
  }

  const response = err.response;

  if (!response) {
    return "Connection problem — please try again";
  }

  if (response.status === 413) {
    return "This file is too large to upload";
  }

  let message =
    response.data?.message ||
    (typeof response.data === "string" ? response.data : null);

  if (Array.isArray(message)) {
    message = message[0];
  }

  if (typeof message === "string" && message.trim().length) {
    return message.trim();
  }

  return null;
}
